module.exports = __webpack_public_path__ + "img/type3_check1.83174fe6.png";